import React, { useEffect, useState } from 'react'
import { ALL_USERS, RESTORE_USER, GET_USER } from 'api/UserConstants'
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, MenuItem, Chip, TextField, Typography, Box, Tooltip } from '@mui/material'
import commonStyles from 'styles/CommonStyles'
import EnhancedTableHead from "components/common/EnhancedTableHead2";
// import EditUserDialog from './EditUserDialog'
import ReuseConfirmationDialog from 'components/common/ReuseConfirmationDialog2'
import SearchBar from 'components/common/SearchBar';
import EditUserDialog from './EditUserDialog';
import AppActions from 'components/app/actions';
import { UPDATE_CHANGE_REQ } from 'api/AuthConstants';

export default () => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});
    const [editUserDialogOpen, setEditUserDialogOpen] = useState(false);
    const [suspendConfirmationDialogOpen, setSuspendConfirmationDialogOpen] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    const [order, setOrder] = useState('asc')
    const [orderBy, setOrderBy] = useState('firstname')
    const [filters, setFilters] = useState({
        userStatus: 'ACTIVE',
        role: 'all',
        affiliation: '',
        title: ''
    })
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const { setToastMessage } = AppActions();

    const commonClasses = commonStyles();

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const handleEditUserDialogOpen = (user) => {
        setSelectedUser(user);
        setEditUserDialogOpen(true);
    }

    const handleEditUserDialogClose = () => {
        setEditUserDialogOpen(false);
    }

    const handleSuspendUser = (user) => {
        setSelectedUser(user);
        setSuspendConfirmationDialogOpen(true);
    }

    const fetchUsers = (limit, offset, filters, order, orderBy, search) => {
        fetch(ALL_USERS,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "limit": limit,
                    "offset": offset,
                    "search": search,
                    "filters": {
                        "user_status": filters.userStatus,
                        "role": filters.role,
                        "affiliation": filters.affiliation,
                        "title": filters.title
                    },
                    "order": order,
                    "order_by": orderBy
                })
            })
            .then(res => res.json())
            .then(data => {
                setUsers(data.users || []);
                setTotalCount(data.total_count);
            })
            .catch(err => {
                console.log(err);
            })
    }


    const updateStatus = (user, status = "approve") => {
        fetch(`${UPDATE_CHANGE_REQ}/${user.change_request_id}/${status}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(res => res.json())
            .then(data => {
                if (data.id) {
                    setUsers(users.filter(user => user.id !== user.id));
                    setToastMessage({
                        message: 'User status updated successfully',
                        type: 'success',
                    })
                } else {
                    setToastMessage({
                        message: data.message,
                        type: 'error',
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }



    const editUserFormSubmit = (updatedUser) => {
        const id = updatedUser.id;
        fetch(GET_USER(id), {
            method: 'PUT',
            body: JSON.stringify(updatedUser),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.id !== id) {
                    throw new Error('User not updated');
                }
                setUsers(users.map(user => {
                    if (user.id === id && data.id === id) {
                        return data;
                    }
                    return user;
                }
                ))
                setToastMessage({
                    message: 'User updated successfully',
                    type: 'success'
                })
            })
            .catch(err => {
                console.log(err)
                setToastMessage({
                    message: 'An error occurred while updating user',
                    type: 'error'
                })
            })
            .finally(() => {
                handleEditUserDialogClose();
            }
            )
    }

    const suspendUser = (id) => {
        fetch(GET_USER(id), {
            method: 'DELETE'
        })
            .then(res => res.json())
            .then(data => {
                if (data.id) {
                    switch (filters.userStatus) {
                        case 'ACTIVE':
                            setUsers(users.filter(user => user.id !== id));
                            break;
                        case 'all':
                            setUsers(users.map(user => {
                                if (user.id === id) {
                                    return { ...user, active: false }
                                }
                                return user;
                            }
                            ))
                            break;
                        default:
                            break;
                    }
                    setToastMessage({
                        message: 'User suspended successfully',
                        type: 'success'
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const restoreUser = (id) => {
        fetch(RESTORE_USER(id), {
            method: 'PUT'
        })
            .then(res => res.json())
            .then(data => {
                if (data.id) {
                    switch (filters.userStatus) {
                        case 'SUSPENDED':
                            setUsers(users.filter(user => user.id !== id));
                            break;
                        case 'all':
                            setUsers(users.map(user => {
                                if (user.id === id) {
                                    return { ...user, active: false }
                                }
                                return user;
                            }
                            ))
                            break;
                        default:
                            break;
                    }
                    setToastMessage({
                        message: 'User restored successfully',
                        type: 'success'
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const roleFilterOptions = [
        { value: 'all', label: 'All' },
        { value: 'USER', label: 'User' },
        { value: 'ADMIN', label: 'Admin' },
    ];

    const userStatusFilterOptions = [
        { value: 'all', label: 'All' },
        { value: 'ACTIVE', label: 'Active' },
        { value: 'PENDING_APPROVAL', label: 'Pending Approval' },
        { value: 'SUSPENDED', label: 'Suspended' },
    ]

    const headCells = [
        { id: 'firstname', disablePadding: false, label: 'Name', width: 120 },
        { id: 'email', disablePadding: false, label: 'Email', width: 120 },
        { id: 'role', disablePadding: false, label: 'Role', width: 120 },
        { id: 'affiliation', disablePadding: false, label: 'Affiliation', width: 200 },
        { id: 'title', disablePadding: false, label: 'Title', width: 200 },
        { id: 'created_at', disablePadding: false, label: 'Created At', width: 120 },
        { id: 'actions', disablePadding: true, label: 'Actions', width: 200, disableSort: true },
    ];

    useEffect(() => {
        fetchUsers(rowsPerPage, page * rowsPerPage, filters, order, orderBy, search);
    }, [page, rowsPerPage, order, orderBy])

    useEffect(() => {
        setPage(0);
        fetchUsers(rowsPerPage, page * rowsPerPage, filters, order, orderBy, search);
    }, [filters, search])

    return (
        <>
            <div>
                {userStatusFilterOptions.map((option) => (
                    <Chip key={option.value} label={option.label} onClick={() => setFilters({ ...filters, userStatus: option.value })} color={filters.userStatus === option.value ? 'primary' : 'default'} style={{ marginRight: '0.5rem' }} />
                ))}
            </div>
            <SearchBar handleSearch={(search) => setSearch(search)} helpText="Search by name or email" />
            <TableContainer style={{ marginTop: '1rem' }}>
                <Table>
                    <EnhancedTableHead
                        columns={headCells}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                    />
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={2} />
                            <TableCell>
                                <TextField
                                    size="small"
                                    select
                                    label="Role"
                                    value={filters.role}
                                    onChange={(e) => setFilters({ ...filters, role: e.target.value })}
                                    style={{ width: '100%' }}
                                >
                                    {roleFilterOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <TextField
                                    size="small"
                                    label="Affiliation"
                                    value={filters.affiliation}
                                    onChange={(e) => setFilters({ ...filters, affiliation: e.target.value })}
                                    style={{ width: '100%' }}
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    size="small"
                                    label="Title"
                                    value={filters.title}
                                    onChange={(e) => setFilters({ ...filters, title: e.target.value })}
                                    style={{ width: '100%' }}
                                />
                            </TableCell>
                            <TableCell colSpan={2} />
                        </TableRow>
                        {users.map((user) => (
                            <TableRow key={user.id}>
                                <TableCell>{user.firstname} {user.lastname}</TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{user.role}</TableCell>
                                <TableCell>{user.affiliation}</TableCell>
                                <TableCell>{user.title}</TableCell>
                                <TableCell>{user.created_at}</TableCell>
                                <TableCell>
                                    <div className={commonClasses.tableActions}>
                                        {user.active === true && (
                                            <>
                                                <Button size="small" variant='outlined' onClick={() => handleEditUserDialogOpen(user)}>Edit</Button>
                                                <Button size="small" variant='outlined' color="secondary" onClick={() => handleSuspendUser(user)}>Suspend</Button>
                                            </>
                                        )}
                                        {user.status === 'PENDING_ACTIVATION' && (
                                            <>
                                                <Button size="small" variant='outlined' onClick={() => updateStatus(user, 'approve')}>Approve</Button>
                                                <Button size="small" variant='outlined' color="secondary" onClick={() => updateStatus(user, 'deny')}>Reject</Button>
                                            </>
                                        )}
                                        {user.active === false && user.status !== 'PENDING_ACTIVATION' && (
                                            <Button size="small" variant='outlined' onClick={() => restoreUser(user.id)}>Restore</Button>
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
            <EditUserDialog open={editUserDialogOpen} handleClose={handleEditUserDialogClose} handleFormSubmit={editUserFormSubmit} user={selectedUser} />
            <ReuseConfirmationDialog
                open={suspendConfirmationDialogOpen}
                handleConfirm={() => {
                    suspendUser(selectedUser.id)
                    setSuspendConfirmationDialogOpen(false)
                }}
                handleCancel={setSuspendConfirmationDialogOpen}
                title={`Suspend ${selectedUser.firstname} ${selectedUser.lastname} (${selectedUser.email})`}
            >
                <Typography variant="body1" paragraph> Are you sure you want to suspend this user?</Typography>
                <Typography variant="body1" paragraph> You can still reactivate the user later.</Typography>
            </ReuseConfirmationDialog>
        </>
    )
}
